enum PlanName {
  BASIC = "basic",
  PRO = "pro",
  FULL_SERVICE = "full-service"
};

export default PlanName;